export default __webpack_public_path__ + "static/media/9 Wating Area Female.05e9d4dd.JPG";